import React from "react";
import { ItemInLegend } from "./ItemInLegend";
import { colorsByType } from "./sc-analyzer-frontend-data";

/**
 * @param props {{
 *  scState:scState
 * }}
 */
export default function Legend({ scState }) {
  return <div css={`display:flex;`}>
    <div css={`padding-right:8px;`}>
      <ItemInLegend item="Events" color={colorsByType.event.bg} />
      <ItemInLegend item="Modifiers" color={colorsByType.modifier.bg} />
      <ItemInLegend item="Storage" color={colorsByType.storage.bg} />
    </div>
    <div css={`padding-right:8px;`}>
      <ItemInLegend item="Block & TX Data" color={colorsByType["block-tx-data"].bg} />
      <ItemInLegend item="Public Functions" color={colorsByType["public-function"].bg} />
      <ItemInLegend item="Readonly Ext Functions" color={colorsByType["readonly-public-function"].bg} />
    </div>
    <div>
      <ItemInLegend item="Other" color={colorsByType.other} />
    </div>
  </div>
}